module.exports = __webpack_public_path__ + "static/img/noData.76e74d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/activityCenter/noData.png
// module id = cBLL
// module chunks = 1